import { render } from "./ManagingMembers.vue?vue&type=template&id=8b7f4220&ts=true"
import script from "./ManagingMembers.vue?vue&type=script&lang=ts"
export * from "./ManagingMembers.vue?vue&type=script&lang=ts"

import "./ManagingMembers.vue?vue&type=style&index=0&id=8b7f4220&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__